export const selectOption = (user) => {
  window.currentOption = user.id;
  return {
    type: 'Option clicked',
    payload: user,
  };
};
